module.exports = __webpack_public_path__ + "img/icon_esec.7fd9ae42.svg";